'use strict';

var typography = require('../../../../../../../../../../_virtual/typography5.cjs');

var hasRequiredTypography;

function requireTypography () {
	if (hasRequiredTypography) return typography.__exports;
	hasRequiredTypography = 1;

	var TYPOGRAPHY_VARIANTS = /*#__PURE__*/ function(TYPOGRAPHY_VARIANTS) {
	    TYPOGRAPHY_VARIANTS["h1"] = "h1";
	    TYPOGRAPHY_VARIANTS["h2"] = "h2";
	    TYPOGRAPHY_VARIANTS["h3"] = "h3";
	    TYPOGRAPHY_VARIANTS["h4"] = "h4";
	    TYPOGRAPHY_VARIANTS["h5"] = "h5";
	    TYPOGRAPHY_VARIANTS["body"] = "body";
	    TYPOGRAPHY_VARIANTS["callout"] = "callout";
	    TYPOGRAPHY_VARIANTS["footnote"] = "footnote";
	    TYPOGRAPHY_VARIANTS["caption"] = "caption";
	    TYPOGRAPHY_VARIANTS["subcaption"] = "subcaption";
	    TYPOGRAPHY_VARIANTS["smallest"] = "smallest";
	    return TYPOGRAPHY_VARIANTS;
	}({});

	typography.__exports.TYPOGRAPHY_VARIANTS = TYPOGRAPHY_VARIANTS;
	
	return typography.__exports;
}

exports.__require = requireTypography;
//# sourceMappingURL=typography.cjs.map
